import styled from "styled-components";
import { Radio } from "antd";
import { theme } from "../../../config";

export const RadioStyled = styled(Radio)`
  height: 30px;

  span.ant-radio + * {
    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 12.6px;
      line-height: 16px;
    }
  }
`;
